module.exports = __webpack_public_path__ + "img/season-light.8841fae2.svg";